import React from 'react';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import PhoneEnabledIcon from '@material-ui/icons/PhoneEnabled';
import ArrowRightIcon from '@material-ui/icons/ArrowRight';
import { purple, green, red, blue, indigo, teal } from '@material-ui/core/colors';
import CustomButton from './CustomButton';

// スタイルを定義
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      padding: theme.spacing(2),
      flexGrow: 1,
    },
  })
);

function GuideBook() {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <div className="wraper">

        <Box my={8}>
          <Typography className="font-weight-bold my-3" variant="h5" component="h2">
            デーリー東北の書籍
          </Typography>
          　デーリー東北新聞社では、自然や郷土の歴史、文化・芸術など様々なジャンルの書籍を取り揃えております。<br/>
          　どれも、大変読み応えのある内容となっておりますので、是非お手にとってご覧下さい。<br/>
          <Box my={4} textAlign="center">
            <Grid className="p-3" spacing={0} container direction="row" justify="center">
              <Grid item xs={12} md={4}>
                <CustomButton href="/book" className="px-4 m-2 d-block" size="large" themeColor={red}>
                  詳　細
                </CustomButton>
              </Grid>
            </Grid>
          </Box>
        </Box>

        <Box my={8}>
          <Grid spacing={0} container direction="row" justify="center">
            <Grid item xs={12} md={7}>
              <Typography className="font-weight-bold my-3" variant="h5" component="h2">
                「カナエルはちのへ」
              </Typography>
              　デーリー東北新聞社は２０１９年２月から、地域の未来を担う中学・高校生の職業観を育てる情報誌「カナエルはちのへ」を発行しています。<br/>
              　八戸圏域に事業所を置く企業・団体の協賛を得て制作し、学校を通じて八戸市内の中高生と三戸郡内の高校生全員に継続的に無償配布しています。地元企業や、そこで働く人の思いなどを紹介し、中高生が自分の将来について考えを深めるきっかけにしてもらうと同時に、地域経済を支える企業の人材確保を支援します。<br/>
              　Ａ４判、基本32ページ（創刊号28ページ）、オールカラー、年２回発行。個別の配布希望にはお応えできませんので、ご了承ください。<br/>
              　同誌の趣旨に賛同し、ご協賛いただける企業・団体を随時募集中です。申し込み、問い合わせ先は「カナエルはちのへ」協賛担当（地域ビジネス局）＝電話0178（80）7095、メールアドレスkanaeru@daily-tohoku.co.jp<br/>
              {/*
              　デーリー東北新聞社は、地域の未来を担う中学・高校生の職業観を育てる情報誌「カナエルはちのへ」を創刊しました。<br/>
              　八戸圏域に事業所を置く企業・団体の協賛を得て制作。学校を通じて八戸市内の全ての中高生に継続的に無償配布します。地元企業や、そこで働く人の思いなどを紹介し、中高生が自分の将来について考えを深めるきっかけにしてもらうと同時に、地域経済を支える企業の人材確保を支援します。<br/>
              　Ａ４判、基本32ページ（創刊号28ページ）、オールカラー、年２回発行。個別の配布希望にはお応えできませんので、ご了承ください。次回は６月発行予定。<br/>
              　同誌の趣旨に賛同し、ご協賛いただける企業・団体を随時募集中です。申し込み、問い合わせ先は「カナエルはちのへ」協賛担当（広告営業部）＝電話0178（44）5111、メールアドレスkanaeru@daily-tohoku.co.jp<br/>
              */}
            </Grid>
            <Grid item xs={12} md={5}>
              <Box p={2} textAlign="center">
                <img src="/images/kanaeru/kanaeru.jpg" className="img-fluid" />
              </Box>
            </Grid>
          </Grid>
        </Box>

      </div>
    </div>
  );
}

export default GuideBook;
